<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_81')"
    icon="res-billstatistic"
    :res-name="getBrandName(detailData.brand)"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :hiddenKindTabs="hiddenKindTabs"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :defaultBrand="detailData.brand"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import { getBrandName } from '@/utils/common/hypervisor'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillBrandSidePage',
  components: {
    Actions,
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
      getBrandName,
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillBrandSidePage'
        default:
          return ''
      }
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || 'month'
      return { dateParam, dateMode }
    },
    hiddenKindTabs () {
      if (this.isDomainMode) {
        return ['domain', 'platform', 'external_project']
      } else if (this.isProjectMode) {
        return ['domain', 'project', 'platform', 'external_project']
      }
      return ['platform', 'external_project']
    },
  },
}
</script>
